import { ReservationWithDetails } from 'webReservations/reservationDetails/apiHelpers';
import { ReservationAttributesGrid } from 'webReservations/reservations/ReservationAttributesGrid';
import { useGuestLandingPaths } from 'webReservations/hooks/useGuestLandingPaths';
import { Icon } from '@components/icon/Icon';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import typography from '~styles/typography.scss';
import styles from './OriginalReservationCard.scss';

interface OriginalReservationCard {
  reservation: ReservationWithDetails;
}

export const OriginalReservationCard = ({
  reservation,
}: OriginalReservationCard) => {
  const { reservationDetailsPath } = useGuestLandingPaths();

  return (
    <section
      className={styles.container}
      aria-label="original reservation details"
    >
      <header className={styles.header}>
        <h3 className={cx(typography.h8, styles.heading)}>
          Your Original Reservation
        </h3>
        <Link
          className={cx(typography.t3, styles.cancel)}
          to={reservationDetailsPath(reservation.id, reservation.restaurant)}
        >
          <Icon name="close" className={styles.cancelIcon} />
          Cancel Changes
        </Link>
      </header>
      <ReservationAttributesGrid
        variant="inline"
        containerClassName={styles.reservationAttributesContainer}
        date={reservation.date}
        guestCount={reservation.guestCount}
        time={reservation.time}
        publicName={null}
      />
    </section>
  );
};
